import { render, staticRenderFns } from "./dash.vue?vue&type=template&id=1127fa4a&scoped=true"
import script from "./dash.vue?vue&type=script&lang=js"
export * from "./dash.vue?vue&type=script&lang=js"
import style0 from "./dash.vue?vue&type=style&index=0&id=1127fa4a&prod&lang=scss&scoped=true"
import style1 from "./dash.vue?vue&type=style&index=1&id=1127fa4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1127fa4a",
  null
  
)

export default component.exports